<div class="col-md-12">
  <div class="row-no-margin">
    <span class="popup-header" [hidden]="!IsNew">Add New File</span>
    <span class="popup-header" [hidden]="IsNew">Edit File</span>
  </div>
  <div class="row-no-margin">
    <div class="col-md-8 clear-padding">
      <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
        <mat-label>Description</mat-label>
        <input matInput class="mat-focused" [(ngModel)]="NewFile.Description" id="txtFileDescription" />
      </mat-form-field>

    </div>
  </div>
  <div class="row-no-margin">
    <div class="col-md-8 clear-padding" >
      <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
        <mat-label>Type</mat-label>
        <!--<label for="fileType" class="col-form-label">Type</label>-->
        <mat-select id="fileType" [(value)]="NewFile.Type">
          <mat-option value="upload">
            File Upload
          </mat-option>
          <mat-option value="directlink">
            Direct Link
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row-no-margin">
    
    <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload />
    <div class="col-md-8" style="padding-bottom:21px;" [hidden]="NewFile.Type != 'upload'">
      {{NewFile.FileName || "No file uploaded yet."}}
      <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUpload.click()">
        <mat-icon>attach_file</mat-icon>
      </button>
    </div>
    <div class="col-md-8 clear-padding" [hidden]="NewFile.Type != 'directlink'">
      <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
        <mat-label>File URL</mat-label>
        <input matInput class="mat-focused" [(ngModel)]="NewFile.FileName" id="txtLink" />
      </mat-form-field>

    </div>
  </div>
  <div class="row-no-margin">
    <div class="col-md-8 clear-padding">
      <app-category-select IsRoot="true" [SelectedCategory]="NewFile.Category" [cats]="Categories" (CategorySelected)="SetCategoryParent($event)">

      </app-category-select>     
    </div>
  </div>
  <div class="row-no-margin">
    <div class="col-md-8 clear-padding" >
      <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
        <mat-label>Enabled For</mat-label>
        <mat-select id="userRole" [(value)]="NewFile.EnabledFor">
          <mat-option value="all">
            All Users
          </mat-option>
          <mat-option value="administrator">
            Administrator
          </mat-option>
          <mat-option value="distributor-manager">
            Distributor Manager
          </mat-option>
          <mat-option value="distributor">
            Distributor
          </mat-option>
          <mat-option value="user">
            User
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <!--<div class="form-group row">
    <button (click)="UploadFile()">Upload</button>
  </div>-->
</div>
